@import 'src/styles/palette';

.assignmentContainer {
  display: flex;
  margin-right: auto;
}

.buttonContainer {
  display: flex;
  justify-content: flex-end;
  padding-top: 1em;
  gap: 1em;
  width: 100%;
  flex-wrap: wrap;
}

.selectMaxWidth {
  max-width: 310px;
}

.rowButton {
  height: 2rem;
  width: 2rem;
}

.checkbox * {
  color: _palette(secondary);
}

.localAlert {
  padding-top: 16px;
}

.fordelingTable {
  .rowStatusIcon {
    align-items: center;
    color: _palette(secondary);
    display: inline-flex;
    justify-content: center;
    vertical-align: middle;
  }

  tr.nothingSelected {
    .rowStatusIcon {
      color: grey;
    }
  }

  tbody tr:hover {
    background-color: _palette(table-row-sky) !important;
  }

  th:nth-child(5),
  td:nth-child(5) {
    text-align: center;
  }
}

.dashedSquareWithShadow {
  height: 100px;
  margin: 0 auto 20px;
  position: relative;
  width: 100px;

  .shadow {
    border: solid _palette(bg-primary-dark);
    border-bottom-width: 40px;
    border-left-width: 50px;
    border-radius: 10px;
    border-right-width: 50px;
    border-top-width: 40px;
    left: 50px;
    position: absolute;
    top: 20px;
    transform: skew(-50deg);
  }

  .dashedSquare {
    border: 10px dashed #999;
    border-radius: 10px;
    height: 100px;
    margin: auto;
    position: absolute;
    width: 100px;
  }
}

.numUnassigned {
  width: 5rem;
}

.unassigned {
  margin: auto 2rem auto 0.5rem;
}

.flex {
  display: flex;
}

.praksisstedWrapper {
  position: relative;
  display: flex;
  align-items: center;

  &.setValue {
    height: 85%;
  }

  .valueHoverCard {
    position: absolute;
    top: 0.5em;
    right: 1.5em;
  }
}

.errorLabelWrapper {
  display: flex;
  align-items: center;
}
